import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { PageViewAbstract } from '../../../../page-view.abstract';
import { LocalPage } from '../../../page.decorator';
import { CmsBlogContentPostListingViewComponent } from '../../content/post-listing/cms-blog-content-post-listing.component';
import { NBlogCategoryPageType } from '../category-view/cms-blog-page-category-view.component';
import { NBlogRootPageType } from './cms-blog-root-page.namespace';

export const BLOG_TAB = 'Blog';

@ICmsPageType({
    id: NBlogRootPageType.typeId,
    title: 'Blog root',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.topCopy',
            title: 'Top copy',
            canShow: d => !d.useParent,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.tagRedirect',
            title: 'Redirect location on tag change',
            default: true,
            tab: BLOG_TAB
        }
    ]
})
@Component({
    selector: 'cms-blog-page-root-view',
    templateUrl: './cms-blog-page-root-view.html',
    standalone: true,
    imports: [CmsBlogContentPostListingViewComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogPageRootViewComponent extends PageViewAbstract {
    @Input()
    override model?: LocalPage<IPageDataV3<NBlogCategoryPageType.ITypeData>>;
}
